/* Boss Up Jewels accessibility and storefront safeguards — staged theme only */
(function () {
  document.addEventListener('click', function (event) {
    var option = event.target.closest && event.target.closest('main-product .product__details .option-item');
    if (!option || window.matchMedia('(max-width: 767px)').matches) return;
    var root = option.closest('main-product');
    var rootId = root && root.id;
    [200, 700, 1500, 2500].forEach(function (delay) {
      window.setTimeout(function () {
        var currentRoot = rootId && document.getElementById(rootId);
        if (!currentRoot) return;
        var select = currentRoot.querySelector('select.variant-select');
        var mapElement = currentRoot.querySelector('[data-bossup-variant-media-map]');
        if (!select || !mapElement) return;
        var map;
        try { map = JSON.parse(mapElement.textContent || '{}'); }
        catch (error) { return; }
        var mediaId = map[String(select.value)];
        var thumbnail = mediaId && currentRoot.querySelector('.thumbnail-img[data-media-id="' + mediaId + '"]');
        if (thumbnail) {
          var carousel = currentRoot.querySelector('.main_carousel');
          var mediaIndex = Number(thumbnail.dataset.thumbIndex);
          if (carousel && carousel.swiper && Number.isFinite(mediaIndex)) carousel.swiper.slideTo(mediaIndex);
          else thumbnail.click();
        }
      }, delay);
    });
  }, true);
})();

(function () {
  function polish() {
    document.querySelectorAll('a.header-logo').forEach(function (link) {
      if (link.getAttribute('href')) link.setAttribute('href', link.getAttribute('href').trim() || '/');
    });
    var search = document.getElementById('search-icon');
    if (search) search.setAttribute('href', '/search');
    document.querySelectorAll('[aria-label="Increament"]').forEach(function (button) {
      button.setAttribute('aria-label', 'Increment');
    });
    document.querySelectorAll('button[data-bs-target^="#pane-details-"]').forEach(function (button) {
      var panel = document.querySelector(button.getAttribute('data-bs-target'));
      if (panel && /product details coming soon/i.test(panel.textContent || '')) {
        var item = button.closest('li');
        if (item) item.hidden = true;
        panel.hidden = true;
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', polish);
  else polish();
})();

/* Desktop color/style choices open their assigned product image. */
window.bossUpSelectVariantMedia = function (option) {
  if (window.matchMedia('(max-width: 767px)').matches) return;
  var productRoot = option && option.closest('main-product');
  var rootId = productRoot && productRoot.id;
  [200, 700, 1500, 2500].forEach(function (delay) {
    window.setTimeout(function () {
      var currentRoot = rootId && document.getElementById(rootId);
      if (!currentRoot) return;
      var select = currentRoot.querySelector('select.variant-select');
      var mapElement = currentRoot.querySelector('[data-bossup-variant-media-map]');
      if (!select || !mapElement) return;
      var map;
      try { map = JSON.parse(mapElement.textContent || '{}'); }
      catch (error) { return; }
      var mediaId = map[String(select.value)];
      var thumbnail = mediaId && currentRoot.querySelector('.thumbnail-img[data-media-id="' + mediaId + '"]');
      if (thumbnail) thumbnail.click();
    }, delay);
  });
};

(function () {
  if (!document.querySelector('main-product')) return;

  var scheduled = false;

  function mobileColorways() {
    scheduled = false;
    var mobile = window.matchMedia('(max-width: 767px)').matches;

    document.querySelectorAll('main-product').forEach(function (product) {
      var existingRail = product.querySelector('.bossup-mobile-colorways');

      if (!mobile) {
        if (existingRail) existingRail.remove();
        return;
      }

      var source = product.querySelector('.product__details .variants_container');
      var media = product.querySelector('.product__media');
      if (!source || !media || !source.querySelector('.variant-options, .variant-selection')) {
        if (existingRail) existingRail.remove();
        return;
      }

      var signature = source.innerHTML;
      if (existingRail && existingRail.dataset.signature === signature && existingRail.parentElement === media) return;
      if (existingRail) existingRail.remove();

      var rail = document.createElement('div');
      rail.className = 'bossup-mobile-colorways';
      rail.setAttribute('aria-label', 'Choose a color or style');
      rail.dataset.signature = signature;
      rail.innerHTML = signature;

      rail.querySelectorAll('[id]').forEach(function (node) { node.removeAttribute('id'); });
      rail.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (node) { node.removeAttribute('data-bs-toggle'); });

      rail.addEventListener('click', function (event) {
        var choice = event.target.closest('.option-item');
        if (!choice) return;
        event.preventDefault();
        var list = choice.closest('.variant-options');
        var index = Array.prototype.indexOf.call(rail.querySelectorAll('.variant-options'), list);
        var sourceLists = source.querySelectorAll('.variant-options');
        var sourceChoice = sourceLists[index] && sourceLists[index].querySelector('[data-value="' + CSS.escape(choice.dataset.value) + '"]');
        if (sourceChoice) sourceChoice.click();
      });

      rail.addEventListener('change', function (event) {
        if (!event.target.matches('.variant-selection')) return;
        var selects = rail.querySelectorAll('.variant-selection');
        var index = Array.prototype.indexOf.call(selects, event.target);
        var sourceSelect = source.querySelectorAll('.variant-selection')[index];
        if (sourceSelect) {
          sourceSelect.value = event.target.value;
          sourceSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      media.appendChild(rail);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(mobileColorways);
  }

  var style = document.createElement('style');
  style.textContent = '@media (max-width:767px){main-product .product__media{position:relative!important}main-product .product__details .variants_container{display:none!important}main-product .bossup-mobile-colorways{position:absolute;z-index:12;right:.5rem;top:50%;transform:translateY(-50%);max-width:7rem;max-height:72%;overflow:auto;padding:.55rem .45rem;background:rgba(255,252,246,.96);border:1px solid #c49a3a;border-radius:1rem;box-shadow:0 .3rem 1rem rgba(27,31,59,.16)}main-product .bossup-mobile-colorways .alert{display:none!important}main-product .bossup-mobile-colorways .variants{margin:0!important}main-product .bossup-mobile-colorways .variants+.variants{margin-top:.55rem!important}main-product .bossup-mobile-colorways .label,main-product .bossup-mobile-colorways label{display:block!important;margin:0 0 .35rem!important;font-size:.68rem!important;line-height:1.1!important;color:#1b1f3b!important;text-align:center}main-product .bossup-mobile-colorways .variant-options{display:flex!important;flex-direction:column!important;align-items:center!important;gap:.45rem!important;margin:0!important}main-product .bossup-mobile-colorways .option-item{min-width:2rem!important;min-height:2rem!important;margin:0!important;padding:.35rem!important;font-size:.68rem!important;line-height:1!important;background-size:cover!important}main-product .bossup-mobile-colorways .option-item.highlighted{outline:2px solid #c49a3a!important;outline-offset:2px!important}main-product .bossup-mobile-colorways select{width:6rem!important;margin:0!important;padding:.45rem!important;font-size:.7rem!important}}';
  style.textContent += '@media (max-width:767px){main-product[data-url*="/products/gemma-collection"] .bossup-mobile-colorways{top:68%;transform:translateY(-50%)}}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  window.addEventListener('resize', schedule);
  new MutationObserver(function (mutations) {
    var relevant = mutations.some(function (mutation) {
      return !mutation.target.closest || !mutation.target.closest('.bossup-mobile-colorways');
    });
    if (relevant) schedule();
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'aria-selected'] });
})();

/* Requests 135-137: selecting a desktop variant opens its assigned product image. */
(function () {
  if (!document.querySelector('main-product')) return;

  function showVariantMedia(root, variantId) {
    if (!root || window.matchMedia('(max-width: 767px)').matches) return;
    var mapElement = root.querySelector('[data-bossup-variant-media-map]');
    if (!mapElement || !variantId) return;

    var mediaMap;
    try {
      mediaMap = JSON.parse(mapElement.textContent || '{}');
    } catch (error) {
      return;
    }

    var mediaId = mediaMap[String(variantId)];
    if (!mediaId) return;
    var thumbnail = root.querySelector('.thumbnail-img[data-media-id="' + CSS.escape(String(mediaId)) + '"]');
    if (thumbnail) thumbnail.click();
  }

  function scheduleVariantMedia(root, variantId) {
    var rootId = root && root.id;
    [100, 400, 900, 1600, 2400, 4000, 6000].forEach(function (delay) {
      window.setTimeout(function () {
        var currentRoot = (rootId && document.getElementById(rootId)) || document.querySelector('main-product');
        if (!currentRoot) return;
        var currentSelect = currentRoot.querySelector('select.variant-select');
        showVariantMedia(currentRoot, currentSelect && currentSelect.value ? currentSelect.value : variantId);
      }, delay);
    });
  }

  document.addEventListener('change', function (event) {
    if (!event.target.matches('select.variant-select')) return;
    scheduleVariantMedia(event.target.closest('main-product'), event.target.value);
  }, true);

  document.addEventListener('click', function (event) {
    var option = event.target.closest('main-product .product__details .option-item');
    if (!option) return;
    scheduleVariantMedia(option.closest('main-product'));
  }, true);

  var selectedByProduct = {};
  window.setInterval(function () {
    if (window.matchMedia('(max-width: 767px)').matches) return;
    document.querySelectorAll('main-product').forEach(function (root, index) {
      var select = root.querySelector('select.variant-select');
      if (!select || !select.value) return;
      var key = root.id || ('product-' + index);
      if (!(key in selectedByProduct)) {
        selectedByProduct[key] = select.value;
        if (new URLSearchParams(window.location.search).has('variant')) {
          scheduleVariantMedia(root, select.value);
        }
        return;
      }
      if (selectedByProduct[key] === select.value) return;
      selectedByProduct[key] = select.value;
      scheduleVariantMedia(root, select.value);
    });
  }, 150);
})();


/* Boss Up recovery: page navigation, paired-product detail links, and visible recommendations. */
(function () {
  function addPageNavigation() {
    if (window.location.pathname === '/' || !document.querySelector('main, #MainContent')) return;
    if (document.querySelector('.bossup-page-navigation')) return;

    var nav = document.createElement('nav');
    nav.className = 'bossup-page-navigation';
    nav.setAttribute('aria-label', 'Page navigation');
    nav.innerHTML =
      '<button type="button" class="bossup-page-navigation__back" aria-label="Go back">← <span>Back</span></button>' +
      '<a class="bossup-page-navigation__home" href="/" aria-label="Go to home page">⌂ <span>Home</span></a>';

    var main = document.querySelector('main, #MainContent');
    if (main) main.insertBefore(nav, main.firstChild);

    var back = nav.querySelector('.bossup-page-navigation__back');
    if (back) back.addEventListener('click', function () {
      if (window.history.length > 1) window.history.back();
      else window.location.assign('/');
    });
  }

  function addPairingLinks() {
    document.querySelectorAll('[data-bu-pairing]').forEach(function (card) {
      if (card.querySelector('.bu-pairing__view-product')) return;
      var titleLink = card.querySelector('.bu-pairing__details > a[href]');
      if (!titleLink || !titleLink.href) return;
      var link = document.createElement('a');
      link.className = 'bu-pairing__view-product';
      link.href = titleLink.href;
      link.textContent = 'View product';
      link.setAttribute('aria-label', 'View ' + (titleLink.textContent || 'paired product').trim());
      titleLink.insertAdjacentElement('afterend', link);
    });
  }

  function moveRecommendations() {
    var headings = Array.prototype.slice.call(document.querySelectorAll('h2, h3'));
    var relatedHeading = headings.find(function (heading) {
      return /you may also love/i.test(heading.textContent || '');
    });
    if (!relatedHeading) return;
    var related = relatedHeading.closest('section') || relatedHeading.parentElement;
    var product = document.querySelector('main-product');
    if (!related || !product || related.dataset.bossupMoved === 'true') return;
    var productSection = product.closest('section') || product.parentElement;
    if (productSection && productSection.parentElement) {
      productSection.insertAdjacentElement('afterend', related);
      related.dataset.bossupMoved = 'true';
    }
  }

  function applyBossUpRecovery() {
    addPageNavigation();
    addPairingLinks();
    moveRecommendations();
  }

  var style = document.createElement('style');
  style.textContent =
    '.bossup-page-navigation{display:flex;align-items:center;gap:.65rem;width:min(1320px,calc(100% - 32px));margin:1rem auto .5rem;color:#182f4e}' +
    '.bossup-page-navigation a,.bossup-page-navigation button{display:inline-flex;align-items:center;gap:.35rem;min-height:2.5rem;padding:.5rem .9rem;border:1px solid rgba(198,154,57,.65);border-radius:999px;background:#fff;color:#182f4e;font:inherit;font-size:.85rem;font-weight:700;text-decoration:none;cursor:pointer}' +
    '.bossup-page-navigation a:hover,.bossup-page-navigation button:hover,.bossup-page-navigation a:focus-visible,.bossup-page-navigation button:focus-visible{background:#f8f5ee;border-color:#c69a39;outline:2px solid transparent}' +
    '.bu-pairing__view-product{display:inline-flex!important;width:max-content;color:#182f4e!important;font-size:.8rem!important;font-weight:700!important;text-decoration:underline!important;text-underline-offset:.18em}' +
    '@media(max-width:767px){.bossup-page-navigation{position:sticky;top:.5rem;z-index:30;width:calc(100% - 24px);margin:.65rem auto;background:rgba(255,255,255,.92);border-radius:999px;backdrop-filter:blur(8px)}.bossup-page-navigation a,.bossup-page-navigation button{flex:1;justify-content:center;min-height:2.75rem}}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyBossUpRecovery);
  else applyBossUpRecovery();

  new MutationObserver(applyBossUpRecovery).observe(document.documentElement, {childList:true, subtree:true});
})();


/* Boss Up full-cart recommendations recovery */
(function () {
  function placeCartRecommendations() {
    if (window.location.pathname.replace(/\/+$/, '') !== '/cart') return;
    var cart = document.querySelector('.main-cart, main-cart, [data-main-cart]');
    var upsell = document.getElementById('cart-upsell-section');
    if (!cart || !upsell) return;

    var gift = cart.querySelector('[data-boss-free-gift]');
    var anchor = gift || cart.querySelector('.cart__footer, [data-cart-footer], form');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(upsell, anchor.nextSibling);
    else cart.appendChild(upsell);

    upsell.hidden = false;
    upsell.removeAttribute('aria-hidden');
    upsell.style.display = '';

    window.setTimeout(function () {
      if (typeof window.cartUpsellRefresh === 'function') window.cartUpsellRefresh();
    }, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', placeCartRecommendations);
  else placeCartRecommendations();

  document.addEventListener('cart:updated', placeCartRecommendations);
  document.addEventListener('cart:refresh', function () {
    window.setTimeout(placeCartRecommendations, 50);
  });
})();


/* Boss Up full-catalog menu and product purchase placement */
(function () {
  var categoryItems = [
    ['Shop All Jewelry', '/collections/all-products'],
    ['Necklaces', '/collections/necklaces'],
    ['Earrings', '/collections/earrings'],
    ['Bracelets', '/collections/bracelets'],
    ['Rings', '/collections/rings'],
    ['Charms', '/collections/charms'],
    ['Pendants', '/collections/pendants']
  ];

  function installCategoryMenu() {
    document.querySelectorAll('header a[href*="/collections/launch-collection"]').forEach(function (link) {
      if (!/shop the heart edit limited launch drop/i.test(link.textContent || '')) return;
      link.textContent = 'Shop by Category';
      link.href = '/collections/all-products';
      var item = link.closest('li') || link.parentElement;
      if (!item || item.querySelector('.bossup-category-menu')) return;
      item.classList.add('bossup-category-host');
      link.setAttribute('aria-haspopup', 'true');
      var menu = document.createElement('ul');
      menu.className = 'bossup-category-menu';
      menu.setAttribute('aria-label', 'Shop by Category');
      categoryItems.forEach(function (entry) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = entry[1];
        a.textContent = entry[0];
        li.appendChild(a);
        menu.appendChild(li);
      });
      item.appendChild(menu);
    });
  }

  function moveShippingNearPurchase() {
    document.querySelectorAll('main-product').forEach(function (product) {
      var shipping = product.querySelector('.product-tax-details');
      var purchase = product.querySelector('.buy_btns_grp');
      var controls = purchase && purchase.querySelector('.product__quantity-cart');
      if (!shipping || !purchase || !controls || shipping.dataset.bossupMoved === 'true') return;
      shipping.classList.add('bossup-shipping-before-cart');
      shipping.dataset.bossupMoved = 'true';
      purchase.insertBefore(shipping, controls);
    });
  }

  function apply() {
    installCategoryMenu();
    moveShippingNearPurchase();
  }

  var style = document.createElement('style');
  style.textContent =
    '.bossup-category-host{position:relative}' +
    '.bossup-category-menu{position:absolute;left:50%;top:100%;transform:translateX(-50%);z-index:100;display:none;min-width:230px;margin:0;padding:.65rem 0;list-style:none;background:#fffaf2;border:1px solid rgba(198,154,57,.55);box-shadow:0 .65rem 1.5rem rgba(27,31,59,.14)}' +
    '.bossup-category-host:hover>.bossup-category-menu,.bossup-category-host:focus-within>.bossup-category-menu{display:block}' +
    '.bossup-category-menu a{display:block!important;padding:.65rem 1rem!important;color:#1b1f3b!important;text-align:left!important;text-decoration:none!important;white-space:nowrap}' +
    '.bossup-category-menu a:hover,.bossup-category-menu a:focus-visible{background:#f1e6c5}' +
    '.bossup-shipping-before-cart{margin:0 0 .75rem;color:inherit}' +
    '@media(max-width:991px){.bossup-category-menu{position:static;display:block;transform:none;min-width:0;margin:.35rem 0 0;box-shadow:none}.bossup-category-menu a{padding:.5rem .75rem!important}}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  new MutationObserver(apply).observe(document.documentElement, { childList: true, subtree: true });
})();


(() => {
  const path = window.location.pathname;
  const rte = document.querySelector('.shopify-policy__body .rte');
  if (!rte) return;

  if (path === '/policies/privacy-policy') {
    const updated = rte.querySelector('p');
    if (updated) updated.classList.add('bossup-policy-updated');
  }

  if (path === '/policies/shipping-policy') {
    rte.querySelectorAll('p').forEach((paragraph) => {
      paragraph.textContent = paragraph.textContent.replace(
        'Delays caused by carriers, weather, holidays, or circumstances outside our control may occur.',
        'Delays may occur.'
      );
    });
  }

  if (path === '/policies/contact-information') {
    rte.classList.add('bossup-contact-policy');
    rte.innerHTML = rte.innerHTML.replaceAll('&nbsp;', ' ');
    const paragraphs = Array.from(rte.querySelectorAll(':scope > p'));
    if (paragraphs[0]) paragraphs[0].classList.add('bossup-contact-policy__intro');
    if (paragraphs.length >= 4) {
      const grid = document.createElement('div');
      grid.className = 'bossup-contact-policy__grid';
      paragraphs[1].before(grid);
      paragraphs.slice(1, 4).forEach((paragraph) => {
        paragraph.classList.add('bossup-contact-policy__card');
        grid.appendChild(paragraph);
      });
    }
    if (paragraphs[4]) paragraphs[4].classList.add('bossup-contact-policy__note');
  }
})();


/* Request 2026-09-17: never show another product's reviews as an empty-state fallback. */
(() => {
  const applyOwnProductReviewRule = () => {
    document.querySelectorAll('.jdgm-review-widget[data-product-id]').forEach((widget) => {
      const productId = widget.getAttribute('data-product-id');
      const badge = document.querySelector(`.jdgm-prev-badge[data-id="${productId}"]`)
        || document.querySelector('.jdgm-prev-badge[data-number-of-reviews]');
      const widgetData = window.jdgm?.data?.reviewWidget?.[productId];
      const countValue = widgetData?.number_of_reviews ?? badge?.getAttribute('data-number-of-reviews');
      if (countValue !== null && countValue !== undefined) {
        widget.classList.toggle('bossup-no-own-reviews', Number(countValue) === 0);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyOwnProductReviewRule);
  else applyOwnProductReviewRule();
  document.addEventListener('jdgm.doneSetup', applyOwnProductReviewRule);
  window.setTimeout(applyOwnProductReviewRule, 1200);
})();
